import { store } from '@context/store';
import { trackAlgoliaEvent } from '@utils/services';
import { useContext } from 'react';
import sessionStorageKeys from '@constants/sessionStorageKeys';
import { isEmpty } from 'lodash';
import HotelDetails from '@customTypes/hotel-details';
import User from '@customTypes/user';
import useSessionStorage from './useSessionStorage';

export default function useAlgoliaEvents() {
  const { getItem, removeItem } = useSessionStorage();
  const { state } = useContext(store);

  const userCameFromSRP = !!(state.referer && state.referer.includes('hotel-day-passes'));

  function algoliaAddedToCartEvent(
    hotelDetails: HotelDetails,
    user: User | undefined,
    sessionID: string,
  ) {
    if (userCameFromSRP) {
      const sessionTrackedHotel = getItem(sessionStorageKeys.ALGOLIA_TRACKED_HOTEL);
      const algoliaTypeAheadStorage = getItem(sessionStorageKeys.ALGOLIA_TYPE_AHEAD);

      // Only fire the event if you reach DLP from SRP.
      if (!isEmpty(sessionTrackedHotel)) {
        const algoliaTrackedHotel = JSON.parse(sessionTrackedHotel);
        const algoliaTypeAhead = algoliaTypeAheadStorage
          ? JSON.parse(algoliaTypeAheadStorage)
          : undefined;

        if (algoliaTrackedHotel.hotel_id === +hotelDetails.id) {
          trackAlgoliaEvent({
            event_type: 'conversion',
            index_name: algoliaTrackedHotel.index_name,
            object_id: algoliaTrackedHotel.object_id,
            position: algoliaTrackedHotel.position,
            query_id: algoliaTrackedHotel.query_id,
            user_token: user ? user.id?.toString() : sessionID,
          });

          // if the user used type ahead,
          // visited a hotel and then added something to the cart,
          // fire a conversion event for that type ahead index & query id.
          if (algoliaTypeAhead) {
            trackAlgoliaEvent({
              event_type: 'conversion',
              index_name: algoliaTypeAhead.type_ahead_index,
              object_id: algoliaTrackedHotel.object_id,
              position: algoliaTrackedHotel.position,
              query_id: algoliaTypeAhead.type_ahead_query_id,
              user_token: user ? user.id?.toString() : sessionID,
            });
          }
        } else {
          removeItem(sessionStorageKeys.ALGOLIA_TRACKED_HOTEL);
          removeItem(sessionStorageKeys.ALGOLIA_TYPE_AHEAD);
        }
      }
    } else {
      removeItem(sessionStorageKeys.ALGOLIA_TRACKED_HOTEL);
      removeItem(sessionStorageKeys.ALGOLIA_TYPE_AHEAD);
    }
  }

  return { algoliaAddedToCartEvent };
}
